import { prefixImageData } from './imageService';
import { selectAccountImagesById } from '../accountImagesSlice';
import type {
    AccountOrAccountOfExternalProduct,
    ProductWithHelpers,
} from '../types/productHelpers';
import type { EnrichProductParameter } from '../configurations/productConfigurationRegistry';

/**
 * Runs base enrichments on the given product. Base enrichment are the ones that are executed for every product (like adding account image to the helpers).
 *
 * In future, it would be best to use injection/registration pattern here, instead of the hardcoded dependencies.
 */
export const runBaseEnrichmentsOnProduct = <T extends AccountOrAccountOfExternalProduct>({
    product,
}: Pick<EnrichProductParameter<T>, 'product'>): ProductWithHelpers<T> => {
    const accountImages = selectAccountImagesById();

    if (!product.id) {
        return product;
    }

    const externalProductImageData =
        product?.productId &&
        prefixImageData(
            accountImages[product.productId]?.imageBase64,
            accountImages[product.productId]?.imageBigBase64,
        );

    const imageData = prefixImageData(
        accountImages[product.id]?.imageBase64,
        accountImages[product.id]?.imageBigBase64,
    );

    return {
        ...product,
        imageData: externalProductImageData || imageData,
    };
};
